import { render, staticRenderFns } from "./DropZoneComponent.vue?vue&type=template&id=237012e1&"
import script from "./DropZoneComponent.vue?vue&type=script&lang=js&"
export * from "./DropZoneComponent.vue?vue&type=script&lang=js&"
import style0 from "./DropZoneComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports